<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="bankList"
      :pagination="false"
      :bordered="true"
      :scroll="{ x: 500 }"
    >
      <template slot="status" slot-scope="text">
        <a-tag :color="getStatusColor(text)">
          {{ getStatusText(text) }}
        </a-tag>
      </template>
    </a-table>
  </div>
</template>

<script>
import { queryBankListById } from '@/api/biz/user'

export default {
  name: 'BankHistory',
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      bankList: [],
      columns: [
        {
          title: '银行卡号',
          dataIndex: 'bankNo',
          align: 'center'
        },
        {
          title: '银行名称',
          dataIndex: 'bankName',
          align: 'center'
        },
        {
          title: '所属支行',
          dataIndex: 'bankSubName',
          align: 'center'
        },
        {
          title: '真实姓名',
          dataIndex: 'realName',
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center'
        }
      ]
    }
  },
  watch: {
    userId: {
      handler(val) {
        if (val) {
          this.getBankList()
        }
      },
      immediate: true
    }
  },
  methods: {
    getBankList() {
      queryBankListById({ id: this.userId }).then(response => {
        this.bankList = response.data
      })
    },
    getStatusColor(status) {
      const statusMap = {
        '1': 'orange',    // 待审核
        '2': 'green',     // 审核成功
        '3': 'red',       // 审核失败
        '4': 'orange',    // 解绑待审核
        '5': 'blue'       // 解绑审核成功
      }
      return statusMap[String(status)] || 'default'
    },
    getStatusText(status) {
      const statusMap = {
        '1': '待审核',
        '2': '审核成功',
        '3': '审核失败',
        '4': '解绑待审核',
        '5': '解绑审核成功'
      }
      return statusMap[String(status)] || '未知状态'
    }
  }
}
</script> 